(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-bundle"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initSliders(section){
      section.querySelectorAll('[data-fd-slider]').forEach(function(s){
        if (s.__fdSlider) return; s.__fdSlider = true;
        var track = s.querySelector('[data-fd-track]');
        var prev = s.querySelector('[data-fd-prev]');
        var next = s.querySelector('[data-fd-next]');
        var dots = s.querySelectorAll('[data-fd-dot]');
        if (!track) return;
        var slides = track.children;
        if (slides.length <= 1) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var activeClass = '';
        if (dots.length) {
          var m = (dots[0].className.match(/fd-[\w-]+__dot/) || [])[0];
          if (m) activeClass = m + '--active';
        }
        function step(dir){
          var w = track.clientWidth;
          var current = Math.round(track.scrollLeft / w);
          var target = Math.max(0, Math.min(slides.length - 1, current + dir));
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); step(-1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); step(1); });
        function updateUi(){
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (dots.length && activeClass) {
            dots.forEach(function(d, i){ d.classList.toggle(activeClass, i === idx); });
          }
          if (prev) prev.style.opacity = idx === 0 ? '.4' : '1';
          if (next) next.style.opacity = idx === slides.length - 1 ? '.4' : '1';
        }
        var scrollTimeout;
        track.addEventListener('scroll', function(){
          if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
          scrollTimeout = requestAnimationFrame(updateUi);
        }, { passive: true });
        updateUi();
      });
    }

    function initBundleSwatches(section){
      var bundles = section.querySelectorAll('.fd-bundle');
      bundles.forEach(function(b){
        if (b.__fdSwatch) return; b.__fdSwatch = true;
        var inputs = b.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var priceEl = b.querySelector('[data-fd-bundle-price]');
        var compareEl = b.querySelector('[data-fd-bundle-compare]');
        var btn = b.querySelector('[data-fd-bundle-btn]');
        var lbl = btn && btn.querySelector('[data-fd-atc-label]');
        var track = b.querySelector('.fd-bundle__track');
        var slides = track ? track.querySelectorAll('.fd-bundle__slide img') : [];
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-price');
          var compare = input.getAttribute('data-fd-compare');
          var pNum = parseInt(input.getAttribute('data-fd-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-available') === 'true';
          var im = input.getAttribute('data-fd-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            lbl.textContent = avail ? 'Ajouter le pack au panier' : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
        var checked = b.querySelector('input[type="radio"][name="id"]:checked');
        if (checked) onChange(checked);
      });
    }

    function updateBubble(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newB = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        var cur = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        if (newB && cur) cur.innerHTML = newB.innerHTML;
      } catch (e) {}
    }
    function updateDrawer(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newC = parsed.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        var cur = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (newC && cur) cur.innerHTML = newC.innerHTML;
      } catch (e) {}
    }
    function openDrawer(){
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var toggles = ['[data-cart-drawer-toggle]','[aria-controls="cart-drawer"]','button[aria-controls*="cart"]','cart-drawer-toggle','a[href="/cart"]'];
      for (var i=0;i<toggles.length;i++){ var el = document.querySelector(toggles[i]); if (el){ el.click(); return true; } }
      ['cart:open','cart-drawer:open','cart:refresh:open'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
      return false;
    }
    function handleAtc(e){
      var form = e.target.closest('[data-fd-atc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var sp = form.querySelector('[data-fd-spinner]');
      if (btn) { btn.setAttribute('aria-busy','true'); btn.disabled = true; }
      if (sp) sp.hidden = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if (!r.ok) throw new Error('atc_'+r.status); return r.json(); })
        .then(function(data){
          if (data && data.sections) { updateDrawer(data.sections['cart-drawer']); updateBubble(data.sections['cart-icon-bubble']); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opened = openDrawer();
          if (!opened) setTimeout(function(){ window.location.href = '/cart'; }, 300);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.disabled = false; } if (sp) sp.hidden = true; });
    }

    if (!window.__fdAtcBound) {
      window.__fdAtcBound = true;
      document.addEventListener('submit', handleAtc);
    }

    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initSliders(section);
      initBundleSwatches(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-bundle-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-bundle-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-final-cta-di1"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initDi1FinalCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      var timers = section.querySelectorAll('[data-fd-countdown]');
      timers.forEach(function(node){
        if (node.__fdDi1Bound) return;
        node.__fdDi1Bound = true;
        var dEl = node.querySelector('[data-fd-d]');
        var hEl = node.querySelector('[data-fd-h]');
        var mEl = node.querySelector('[data-fd-m]');
        var sEl = node.querySelector('[data-fd-s]');
        var timerEl = node.querySelector('[data-fd-timer]');
        var expiredEl = node.querySelector('.fd-countdown__expired');
        var labelEl = node.querySelector('.fd-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
          if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
          if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
          if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }
    function initDi1FinalSection(section){
      if (!section || section.__fdDi1Init) return;
      section.__fdDi1Init = true;
      initDi1FinalCountdowns(section);
    }
    function initDi1FinalAll(){
      document.querySelectorAll('.fd-di1-scope .fd-section.fd-final-section').forEach(initDi1FinalSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDi1FinalAll);
    else initDi1FinalAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-di1-scope .fd-section.fd-final-section');
      if (s) { s.__fdDi1Init = false; initDi1FinalSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-final-cta-di2"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initDi2Countdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      var timers = section.querySelectorAll('[data-fd-di2-countdown]');
      timers.forEach(function(node){
        if (node.__fdDi2Bound) return;
        node.__fdDi2Bound = true;
        var dEl = node.querySelector('[data-fd-di2-d]');
        var hEl = node.querySelector('[data-fd-di2-h]');
        var mEl = node.querySelector('[data-fd-di2-m]');
        var sEl = node.querySelector('[data-fd-di2-s]');
        var timerEl = node.querySelector('[data-fd-di2-timer]');
        var expiredEl = node.querySelector('.fd-countdown__expired');
        var labelEl = node.querySelector('.fd-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
          if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
          if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
          if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }
    function initDi2Section(section){
      if (!section || section.__fdDi2Init) return;
      section.__fdDi2Init = true;
      initDi2Countdowns(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-di2-scope .fd-section.fd-final-section').forEach(initDi2Section);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-di2-scope .fd-section.fd-final-section');
      if (s) { s.__fdDi2Init = false; initDi2Section(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-final-cta-pf"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      var timers = section.querySelectorAll('[data-fd-countdown]');
      timers.forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl = node.querySelector('[data-fd-d]');
        var hEl = node.querySelector('[data-fd-h]');
        var mEl = node.querySelector('[data-fd-m]');
        var sEl = node.querySelector('[data-fd-s]');
        var timerEl = node.querySelector('[data-fd-timer]');
        var expiredEl = node.querySelector('.fd-countdown__expired');
        var labelEl = node.querySelector('.fd-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
          if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
          if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
          if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }
    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initCountdowns(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-final-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-final-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-final-cta-sl"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-sl-deadline')).getTime();
      var timers = section.querySelectorAll('[data-fd-sl-countdown]');
      timers.forEach(function(node){
        if (node.__fdSlBound) return;
        node.__fdSlBound = true;
        var dEl = node.querySelector('[data-fd-sl-d]');
        var hEl = node.querySelector('[data-fd-sl-h]');
        var mEl = node.querySelector('[data-fd-sl-m]');
        var sEl = node.querySelector('[data-fd-sl-s]');
        var timerEl = node.querySelector('[data-fd-sl-timer]');
        var expiredEl = node.querySelector('.fd-sl-countdown__expired');
        var labelEl = node.querySelector('.fd-sl-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
          if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
          if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
          if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }
    function initSection(section){
      if (!section || section.__fdSlInit) return;
      section.__fdSlInit = true;
      initCountdowns(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-sl-section.fd-sl-final-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-sl-section.fd-sl-final-section');
      if (s) { s.__fdSlInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-final-cta-v2"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      var timers = section.querySelectorAll('[data-fd-countdown]');
      timers.forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl = node.querySelector('[data-fd-d]');
        var hEl = node.querySelector('[data-fd-h]');
        var mEl = node.querySelector('[data-fd-m]');
        var sEl = node.querySelector('[data-fd-s]');
        var timerEl = node.querySelector('[data-fd-timer]');
        var expiredEl = node.querySelector('.fd-countdown__expired');
        var labelEl = node.querySelector('.fd-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
          if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
          if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
          if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }
    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initCountdowns(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-final-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-final-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      var timers = section.querySelectorAll('[data-fd-countdown]');
      timers.forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl = node.querySelector('[data-fd-d]');
        var hEl = node.querySelector('[data-fd-h]');
        var mEl = node.querySelector('[data-fd-m]');
        var sEl = node.querySelector('[data-fd-s]');
        var timerEl = node.querySelector('[data-fd-timer]');
        var expiredEl = node.querySelector('.fd-countdown__expired');
        var labelEl = node.querySelector('.fd-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
          if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
          if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
          if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }
    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initCountdowns(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-final-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-final-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero-di-di1"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initDi1Countdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      section.querySelectorAll('[data-fd-countdown]').forEach(function(node){
        if (node.__fdDi1Bound) return;
        node.__fdDi1Bound = true;
        var dEl=node.querySelector('[data-fd-d]'),hEl=node.querySelector('[data-fd-h]'),
            mEl=node.querySelector('[data-fd-m]'),sEl=node.querySelector('[data-fd-s]'),
            timerEl=node.querySelector('[data-fd-timer]'),
            expiredEl=node.querySelector('.fd-hero-di__cd-expired'),
            labelEl=node.querySelector('.fd-hero-di__cd-label'),intervalId;
        function tick(){
          var diff=deadline-Date.now();
          if(diff<=0){if(timerEl)timerEl.hidden=true;if(labelEl)labelEl.hidden=true;if(expiredEl)expiredEl.hidden=false;if(intervalId)clearInterval(intervalId);return;}
          if(dEl)dEl.textContent=pad(Math.floor(diff/864e5));
          if(hEl)hEl.textContent=pad(Math.floor((diff/36e5)%24));
          if(mEl)mEl.textContent=pad(Math.floor((diff/6e4)%60));
          if(sEl)sEl.textContent=pad(Math.floor((diff/1e3)%60));
        }
        tick();intervalId=setInterval(tick,1000);
      });
    }
    function initDi1StickyCta(section){
      var sticky = section.querySelector('.fd-hero-di__sticky-cta');
      var hero = section.querySelector('.fd-hero-di__hero');
      if (!sticky || !hero) return;
      sticky.hidden = false;
      var visClass = 'fd-hero-di__sticky-cta--visible';
      function onScroll(){
        var heroBottom = hero.getBoundingClientRect().bottom;
        if (heroBottom < 0) {
          sticky.classList.add(visClass);
        } else {
          sticky.classList.remove(visClass);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    function initDi1All(){document.querySelectorAll('.fd-di1-scope .fd-section.fd-hero-di').forEach(function(s){if(!s.__fdDi1Init){s.__fdDi1Init=true;initDi1Countdowns(s);initDi1StickyCta(s);}});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initDi1All);else initDi1All();
    document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.fd-di1-scope .fd-section.fd-hero-di');if(s){s.__fdDi1Init=false;initDi1Countdowns(s);initDi1StickyCta(s);}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero-di-di2"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      section.querySelectorAll('[data-fd-di2-countdown]').forEach(function(node){
        if (node.__fdDi2Bound) return;
        node.__fdDi2Bound = true;
        var dEl=node.querySelector('[data-fd-di2-d]'),hEl=node.querySelector('[data-fd-di2-h]'),
            mEl=node.querySelector('[data-fd-di2-m]'),sEl=node.querySelector('[data-fd-di2-s]'),
            timerEl=node.querySelector('[data-fd-di2-timer]'),
            expiredEl=node.querySelector('.fd-hero-di__cd-expired'),
            labelEl=node.querySelector('.fd-hero-di__cd-label'),intervalId;
        function tick(){
          var diff=deadline-Date.now();
          if(diff<=0){if(timerEl)timerEl.hidden=true;if(labelEl)labelEl.hidden=true;if(expiredEl)expiredEl.hidden=false;if(intervalId)clearInterval(intervalId);return;}
          if(dEl)dEl.textContent=pad(Math.floor(diff/864e5));
          if(hEl)hEl.textContent=pad(Math.floor((diff/36e5)%24));
          if(mEl)mEl.textContent=pad(Math.floor((diff/6e4)%60));
          if(sEl)sEl.textContent=pad(Math.floor((diff/1e3)%60));
        }
        tick();intervalId=setInterval(tick,1000);
      });
    }
    function initAll(){document.querySelectorAll('.fd-di2-scope .fd-section.fd-hero-di').forEach(function(s){if(!s.__fdDi2Init){s.__fdDi2Init=true;initCountdowns(s);}});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
    document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.fd-di2-scope .fd-section.fd-hero-di');if(s){s.__fdDi2Init=false;initCountdowns(s);}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero-di-pf"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      section.querySelectorAll('[data-fd-countdown]').forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl=node.querySelector('[data-fd-d]'),hEl=node.querySelector('[data-fd-h]'),
            mEl=node.querySelector('[data-fd-m]'),sEl=node.querySelector('[data-fd-s]'),
            timerEl=node.querySelector('[data-fd-timer]'),
            expiredEl=node.querySelector('.fd-hero-di__cd-expired'),
            labelEl=node.querySelector('.fd-hero-di__cd-label'),intervalId;
        function tick(){
          var diff=deadline-Date.now();
          if(diff<=0){if(timerEl)timerEl.hidden=true;if(labelEl)labelEl.hidden=true;if(expiredEl)expiredEl.hidden=false;if(intervalId)clearInterval(intervalId);return;}
          if(dEl)dEl.textContent=pad(Math.floor(diff/864e5));
          if(hEl)hEl.textContent=pad(Math.floor((diff/36e5)%24));
          if(mEl)mEl.textContent=pad(Math.floor((diff/6e4)%60));
          if(sEl)sEl.textContent=pad(Math.floor((diff/1e3)%60));
        }
        tick();intervalId=setInterval(tick,1000);
      });
    }
    function initAll(){document.querySelectorAll('.fd-section.fd-hero-di').forEach(function(s){if(!s.__fdInit){s.__fdInit=true;initCountdowns(s);}});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
    document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.fd-section.fd-hero-di');if(s){s.__fdInit=false;initCountdowns(s);}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero-di-sl"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-sl-deadline')).getTime();
      section.querySelectorAll('[data-fd-sl-countdown]').forEach(function(node){
        if (node.__fdSlBound) return;
        node.__fdSlBound = true;
        var dEl=node.querySelector('[data-fd-sl-d]'),hEl=node.querySelector('[data-fd-sl-h]'),
            mEl=node.querySelector('[data-fd-sl-m]'),sEl=node.querySelector('[data-fd-sl-s]'),
            timerEl=node.querySelector('[data-fd-sl-timer]'),
            expiredEl=node.querySelector('.fd-sl-hero-di__cd-expired'),
            labelEl=node.querySelector('.fd-sl-hero-di__cd-label'),intervalId;
        function tick(){
          var diff=deadline-Date.now();
          if(diff<=0){if(timerEl)timerEl.hidden=true;if(labelEl)labelEl.hidden=true;if(expiredEl)expiredEl.hidden=false;if(intervalId)clearInterval(intervalId);return;}
          if(dEl)dEl.textContent=pad(Math.floor(diff/864e5));
          if(hEl)hEl.textContent=pad(Math.floor((diff/36e5)%24));
          if(mEl)mEl.textContent=pad(Math.floor((diff/6e4)%60));
          if(sEl)sEl.textContent=pad(Math.floor((diff/1e3)%60));
        }
        tick();intervalId=setInterval(tick,1000);
      });
    }
    function initAll(){document.querySelectorAll('.fd-sl-section.fd-sl-hero-di').forEach(function(s){if(!s.__fdSlInit){s.__fdSlInit=true;initCountdowns(s);}});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
    document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.fd-sl-section.fd-sl-hero-di');if(s){s.__fdSlInit=false;initCountdowns(s);}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero-di-v2"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      section.querySelectorAll('[data-fd-countdown]').forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl=node.querySelector('[data-fd-d]'),hEl=node.querySelector('[data-fd-h]'),
            mEl=node.querySelector('[data-fd-m]'),sEl=node.querySelector('[data-fd-s]'),
            timerEl=node.querySelector('[data-fd-timer]'),
            expiredEl=node.querySelector('.fd-hero-di__cd-expired'),
            labelEl=node.querySelector('.fd-hero-di__cd-label'),intervalId;
        function tick(){
          var diff=deadline-Date.now();
          if(diff<=0){if(timerEl)timerEl.hidden=true;if(labelEl)labelEl.hidden=true;if(expiredEl)expiredEl.hidden=false;if(intervalId)clearInterval(intervalId);return;}
          if(dEl)dEl.textContent=pad(Math.floor(diff/864e5));
          if(hEl)hEl.textContent=pad(Math.floor((diff/36e5)%24));
          if(mEl)mEl.textContent=pad(Math.floor((diff/6e4)%60));
          if(sEl)sEl.textContent=pad(Math.floor((diff/1e3)%60));
        }
        tick();intervalId=setInterval(tick,1000);
      });
    }
    function initAll(){document.querySelectorAll('.fd-section.fd-hero-di').forEach(function(s){if(!s.__fdInit){s.__fdInit=true;initCountdowns(s);}});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
    document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.fd-section.fd-hero-di');if(s){s.__fdInit=false;initCountdowns(s);}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero-di"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      section.querySelectorAll('[data-fd-countdown]').forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl=node.querySelector('[data-fd-d]'),hEl=node.querySelector('[data-fd-h]'),
            mEl=node.querySelector('[data-fd-m]'),sEl=node.querySelector('[data-fd-s]'),
            timerEl=node.querySelector('[data-fd-timer]'),
            expiredEl=node.querySelector('.fd-hero-di__cd-expired'),
            labelEl=node.querySelector('.fd-hero-di__cd-label'),intervalId;
        function tick(){
          var diff=deadline-Date.now();
          if(diff<=0){if(timerEl)timerEl.hidden=true;if(labelEl)labelEl.hidden=true;if(expiredEl)expiredEl.hidden=false;if(intervalId)clearInterval(intervalId);return;}
          if(dEl)dEl.textContent=pad(Math.floor(diff/864e5));
          if(hEl)hEl.textContent=pad(Math.floor((diff/36e5)%24));
          if(mEl)mEl.textContent=pad(Math.floor((diff/6e4)%60));
          if(sEl)sEl.textContent=pad(Math.floor((diff/1e3)%60));
        }
        tick();intervalId=setInterval(tick,1000);
      });
    }
    function initStickyCta(section){
      var sticky = section.querySelector('.fd-hero-di__sticky-cta');
      var hero = section.querySelector('.fd-hero-di__hero');
      if (!sticky || !hero) return;
      sticky.hidden = false;
      var visClass = 'fd-hero-di__sticky-cta--visible';
      function onScroll(){
        var heroBottom = hero.getBoundingClientRect().bottom;
        if (heroBottom < 0) {
          sticky.classList.add(visClass);
        } else {
          sticky.classList.remove(visClass);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    function initAll(){document.querySelectorAll('.fd-section.fd-hero-di').forEach(function(s){if(!s.__fdInit){s.__fdInit=true;initCountdowns(s);initStickyCta(s);}});}
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
    document.addEventListener('shopify:section:load',function(e){var s=e.target.querySelector('.fd-section.fd-hero-di');if(s){s.__fdInit=false;initCountdowns(s);initStickyCta(s);}});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-hero"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initCountdowns(section){
      var container = section;
      var deadline = new Date(container.getAttribute('data-fd-deadline')).getTime();
      var timers = container.querySelectorAll('[data-fd-countdown]');
      timers.forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl = node.querySelector('[data-fd-d]');
        var hEl = node.querySelector('[data-fd-h]');
        var mEl = node.querySelector('[data-fd-m]');
        var sEl = node.querySelector('[data-fd-s]');
        var timerEl = node.querySelector('[data-fd-timer]');
        var expiredEl = node.querySelector('.fd-countdown__expired');
        var labelEl = node.querySelector('.fd-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
          if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
          if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
          if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }
    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initCountdowns(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-hero').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-hero');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-parfums-di1"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initDi1Sliders(section){
      section.querySelectorAll('[data-fd-di1-slider]').forEach(function(s){
        if (s.__fdDi1Slider) return; s.__fdDi1Slider = true;
        var track = s.querySelector('[data-fd-di1-track]');
        var prev = s.querySelector('[data-fd-di1-prev]');
        var next = s.querySelector('[data-fd-di1-next]');
        var dots = s.querySelectorAll('[data-fd-di1-dot]');
        if (!track) return;
        var slides = track.children;
        if (slides.length <= 1) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var activeClass = '';
        if (dots.length) {
          var m = (dots[0].className.match(/fd-[\w-]+__dot/) || [])[0];
          if (m) activeClass = m + '--active';
        }
        function step(dir){
          var w = track.clientWidth;
          var current = Math.round(track.scrollLeft / w);
          var target = Math.max(0, Math.min(slides.length - 1, current + dir));
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); step(-1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); step(1); });
        function updateUi(){
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (dots.length && activeClass) {
            dots.forEach(function(d, i){ d.classList.toggle(activeClass, i === idx); });
          }
          if (prev) prev.style.opacity = idx === 0 ? '.4' : '1';
          if (next) next.style.opacity = idx === slides.length - 1 ? '.4' : '1';
        }
        var scrollTimeout;
        track.addEventListener('scroll', function(){
          if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
          scrollTimeout = requestAnimationFrame(updateUi);
        }, { passive: true });
        updateUi();
      });
    }

    function initDi1ParfumVariants(section){
      var forms = section.querySelectorAll('[data-fd-di1-pcard-form]');
      forms.forEach(function(form){
        if (form.__fdDi1Pcard) return; form.__fdDi1Pcard = true;
        var inputs = form.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var card = form.closest('.fd-parfums__card');
        var priceEl = card && card.querySelector('[data-fd-di1-pcard-price]');
        var compareEl = card && card.querySelector('[data-fd-di1-pcard-compare]');
        var perWashEl = card && card.querySelector('[data-fd-di1-pcard-perwash]');
        var savingsEl = card && card.querySelector('[data-fd-di1-pcard-savings]');
        var fromEl = card && card.querySelector('.fd-parfums__price-from');
        var btn = form.querySelector('[data-fd-di1-pcard-btn]');
        var lbl = btn && btn.querySelector('[data-fd-di1-atc-label]');
        var track = card && card.querySelector('.fd-parfums__track');
        var slides = track ? track.querySelectorAll('.fd-parfums__slide img') : [];
        var defaultLabel = btn && btn.getAttribute('data-fd-di1-default-label');
        if (btn && lbl && !defaultLabel) btn.setAttribute('data-fd-di1-default-label', 'J\'en profite à -20%');
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function formatPerWash(priceCents){
          var euros = (priceCents / 10000);
          var fmt = euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return fmt + ' \u20ac/machine';
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-di1-price');
          var compare = input.getAttribute('data-fd-di1-compare');
          var pNum = parseInt(input.getAttribute('data-fd-di1-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-di1-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-di1-available') === 'true';
          var im = input.getAttribute('data-fd-di1-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          if (perWashEl && pNum) perWashEl.textContent = formatPerWash(pNum);
          if (savingsEl) {
            var s = cNum - pNum;
            if (s > 0) {
              var sFmt = (s/100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              savingsEl.textContent = 'Vous \u00e9conomisez ' + sFmt + ' \u20ac';
              savingsEl.hidden = false;
            } else {
              savingsEl.hidden = true;
            }
          }
          if (fromEl) fromEl.hidden = true;
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            var dflt = btn.getAttribute('data-fd-di1-default-label') || 'J\'en profite \u00e0 -20%';
            lbl.textContent = avail ? dflt : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
      });
    }

    function updateDi1Bubble(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newB = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        var cur = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        if (newB && cur) cur.innerHTML = newB.innerHTML;
      } catch (e) {}
    }
    function updateDi1Drawer(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newC = parsed.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        var cur = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (newC && cur) cur.innerHTML = newC.innerHTML;
      } catch (e) {}
    }
    function openDi1Drawer(){
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var toggles = ['[data-cart-drawer-toggle]','[aria-controls="cart-drawer"]','button[aria-controls*="cart"]','cart-drawer-toggle','a[href="/cart"]'];
      for (var i=0;i<toggles.length;i++){ var el = document.querySelector(toggles[i]); if (el){ el.click(); return true; } }
      ['cart:open','cart-drawer:open','cart:refresh:open'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
      return false;
    }
    function handleDi1Atc(e){
      var form = e.target.closest('[data-fd-di1-atc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var sp = form.querySelector('[data-fd-di1-spinner]');
      if (btn) { btn.setAttribute('aria-busy','true'); btn.disabled = true; }
      if (sp) sp.hidden = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if (!r.ok) throw new Error('atc_'+r.status); return r.json(); })
        .then(function(data){
          if (data && data.sections) { updateDi1Drawer(data.sections['cart-drawer']); updateDi1Bubble(data.sections['cart-icon-bubble']); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opened = openDi1Drawer();
          if (!opened) setTimeout(function(){ window.location.href = '/cart'; }, 300);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.disabled = false; } if (sp) sp.hidden = true; });
    }

    if (!window.__fdDi1AtcBound) {
      window.__fdDi1AtcBound = true;
      document.addEventListener('submit', handleDi1Atc);
    }

    function initDi1Section(section){
      if (!section || section.__fdDi1Init) return;
      section.__fdDi1Init = true;
      initDi1Sliders(section);
      initDi1ParfumVariants(section);
    }
    function initDi1All(){
      document.querySelectorAll('.fd-di1-scope .fd-section.fd-parfums-section').forEach(initDi1Section);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDi1All);
    else initDi1All();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-di1-scope .fd-section.fd-parfums-section');
      if (s) { s.__fdDi1Init = false; initDi1Section(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-parfums-di2"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initDi2Sliders(section){
      section.querySelectorAll('[data-fd-di2-slider]').forEach(function(s){
        if (s.__fdDi2Slider) return; s.__fdDi2Slider = true;
        var track = s.querySelector('[data-fd-di2-track]');
        var prev = s.querySelector('[data-fd-di2-prev]');
        var next = s.querySelector('[data-fd-di2-next]');
        var dots = s.querySelectorAll('[data-fd-di2-dot]');
        if (!track) return;
        var slides = track.children;
        if (slides.length <= 1) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var activeClass = '';
        if (dots.length) {
          var m = (dots[0].className.match(/fd-[\w-]+__dot/) || [])[0];
          if (m) activeClass = m + '--active';
        }
        function step(dir){
          var w = track.clientWidth;
          var current = Math.round(track.scrollLeft / w);
          var target = Math.max(0, Math.min(slides.length - 1, current + dir));
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); step(-1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); step(1); });
        function updateUi(){
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (dots.length && activeClass) {
            dots.forEach(function(d, i){ d.classList.toggle(activeClass, i === idx); });
          }
          if (prev) prev.style.opacity = idx === 0 ? '.4' : '1';
          if (next) next.style.opacity = idx === slides.length - 1 ? '.4' : '1';
        }
        var scrollTimeout;
        track.addEventListener('scroll', function(){
          if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
          scrollTimeout = requestAnimationFrame(updateUi);
        }, { passive: true });
        updateUi();
      });
    }

    function initDi2ParfumVariants(section){
      var forms = section.querySelectorAll('[data-fd-di2-pcard-form]');
      forms.forEach(function(form){
        if (form.__fdDi2Pcard) return; form.__fdDi2Pcard = true;
        var inputs = form.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var card = form.closest('.fd-parfums__card');
        var priceEl = card && card.querySelector('[data-fd-di2-pcard-price]');
        var compareEl = card && card.querySelector('[data-fd-di2-pcard-compare]');
        var perWashEl = card && card.querySelector('[data-fd-di2-pcard-perwash]');
        var savingsEl = card && card.querySelector('[data-fd-di2-pcard-savings]');
        var discountEl = card && card.querySelector('[data-fd-di2-pcard-discount]');
        var fromEl = card && card.querySelector('.fd-parfums__price-from');
        var btn = form.querySelector('[data-fd-di2-pcard-btn]');
        var lbl = btn && btn.querySelector('[data-fd-di2-atc-label]');
        var track = card && card.querySelector('.fd-parfums__track');
        var slides = track ? track.querySelectorAll('.fd-parfums__slide img') : [];
        var defaultLabel = btn && btn.getAttribute('data-fd-di2-default-label');
        if (btn && lbl && !defaultLabel) btn.setAttribute('data-fd-di2-default-label', 'J\'en profite à -20%');
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function formatPerWash(priceCents){
          var euros = (priceCents / 10000);
          var fmt = euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return fmt + ' €/machine';
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-di2-price');
          var compare = input.getAttribute('data-fd-di2-compare');
          var pNum = parseInt(input.getAttribute('data-fd-di2-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-di2-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-di2-available') === 'true';
          var im = input.getAttribute('data-fd-di2-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          if (discountEl) {
            if (cNum > pNum) {
              var pct = Math.round((cNum - pNum) * 100 / cNum);
              discountEl.textContent = '-' + pct + '%';
              discountEl.hidden = false;
            } else {
              discountEl.hidden = true;
            }
          }
          if (perWashEl && pNum) perWashEl.textContent = formatPerWash(pNum);
          if (savingsEl) {
            var s = cNum - pNum;
            if (s > 0) {
              var sFmt = (s/100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              savingsEl.textContent = 'Vous économisez ' + sFmt + ' €';
              savingsEl.hidden = false;
            } else {
              savingsEl.hidden = true;
            }
          }
          if (fromEl) fromEl.hidden = true;
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            var dflt = btn.getAttribute('data-fd-di2-default-label') || 'J\'en profite à -20%';
            lbl.textContent = avail ? dflt : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
      });
    }

    function updateBubbleDi2(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newB = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        var cur = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        if (newB && cur) cur.innerHTML = newB.innerHTML;
      } catch (e) {}
    }
    function updateDrawerDi2(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newC = parsed.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        var cur = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (newC && cur) cur.innerHTML = newC.innerHTML;
      } catch (e) {}
    }
    function openDrawerDi2(){
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var toggles = ['[data-cart-drawer-toggle]','[aria-controls="cart-drawer"]','button[aria-controls*="cart"]','cart-drawer-toggle','a[href="/cart"]'];
      for (var i=0;i<toggles.length;i++){ var el = document.querySelector(toggles[i]); if (el){ el.click(); return true; } }
      ['cart:open','cart-drawer:open','cart:refresh:open'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
      return false;
    }
    function handleDi2Atc(e){
      var form = e.target.closest('[data-fd-di2-atc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var sp = form.querySelector('[data-fd-di2-spinner]');
      if (btn) { btn.setAttribute('aria-busy','true'); btn.disabled = true; }
      if (sp) sp.hidden = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if (!r.ok) throw new Error('atc_'+r.status); return r.json(); })
        .then(function(data){
          if (data && data.sections) { updateDrawerDi2(data.sections['cart-drawer']); updateBubbleDi2(data.sections['cart-icon-bubble']); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opened = openDrawerDi2();
          if (!opened) setTimeout(function(){ window.location.href = '/cart'; }, 300);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.disabled = false; } if (sp) sp.hidden = true; });
    }

    if (!window.__fdDi2AtcBound) {
      window.__fdDi2AtcBound = true;
      document.addEventListener('submit', handleDi2Atc);
    }

    function initDi2Section(section){
      if (!section || section.__fdDi2Init) return;
      section.__fdDi2Init = true;
      initDi2Sliders(section);
      initDi2ParfumVariants(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-di2-scope .fd-section.fd-parfums-section').forEach(initDi2Section);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-di2-scope .fd-section.fd-parfums-section');
      if (s) { s.__fdDi2Init = false; initDi2Section(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-parfums-pf"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initSliders(section){
      section.querySelectorAll('[data-fd-slider]').forEach(function(s){
        if (s.__fdSlider) return; s.__fdSlider = true;
        var track = s.querySelector('[data-fd-track]');
        var prev = s.querySelector('[data-fd-prev]');
        var next = s.querySelector('[data-fd-next]');
        var dots = s.querySelectorAll('[data-fd-dot]');
        if (!track) return;
        var slides = track.children;
        if (slides.length <= 1) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var activeClass = '';
        if (dots.length) {
          var m = (dots[0].className.match(/fd-[\w-]+__dot/) || [])[0];
          if (m) activeClass = m + '--active';
        }
        function step(dir){
          var w = track.clientWidth;
          var current = Math.round(track.scrollLeft / w);
          var target = Math.max(0, Math.min(slides.length - 1, current + dir));
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); step(-1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); step(1); });
        function updateUi(){
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (dots.length && activeClass) {
            dots.forEach(function(d, i){ d.classList.toggle(activeClass, i === idx); });
          }
          if (prev) prev.style.opacity = idx === 0 ? '.4' : '1';
          if (next) next.style.opacity = idx === slides.length - 1 ? '.4' : '1';
        }
        var scrollTimeout;
        track.addEventListener('scroll', function(){
          if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
          scrollTimeout = requestAnimationFrame(updateUi);
        }, { passive: true });
        updateUi();
      });
    }

    function initParfumVariants(section){
      var forms = section.querySelectorAll('[data-fd-pcard-form]');
      forms.forEach(function(form){
        if (form.__fdPcard) return; form.__fdPcard = true;
        var inputs = form.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var card = form.closest('.fd-parfums__card');
        var priceEl = card && card.querySelector('[data-fd-pcard-price]');
        var compareEl = card && card.querySelector('[data-fd-pcard-compare]');
        var perWashEl = card && card.querySelector('[data-fd-pcard-perwash]');
        var savingsEl = card && card.querySelector('[data-fd-pcard-savings]');
        var discountEl = card && card.querySelector('[data-fd-pcard-discount]');
        var fromEl = card && card.querySelector('.fd-parfums__price-from');
        var btn = form.querySelector('[data-fd-pcard-btn]');
        var lbl = btn && btn.querySelector('[data-fd-atc-label]');
        var track = card && card.querySelector('.fd-parfums__track');
        var slides = track ? track.querySelectorAll('.fd-parfums__slide img') : [];
        var defaultLabel = btn && btn.getAttribute('data-fd-default-label');
        if (btn && lbl && !defaultLabel) btn.setAttribute('data-fd-default-label', 'J\'en profite à -20%');
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function formatPerWash(priceCents){
          var euros = (priceCents / 10000);
          var fmt = euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return fmt + ' €/machine';
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-price');
          var compare = input.getAttribute('data-fd-compare');
          var pNum = parseInt(input.getAttribute('data-fd-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-available') === 'true';
          var im = input.getAttribute('data-fd-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          if (discountEl) {
            if (cNum > pNum) {
              var pct = Math.round((cNum - pNum) * 100 / cNum);
              discountEl.textContent = '-' + pct + '%';
              discountEl.hidden = false;
            } else {
              discountEl.hidden = true;
            }
          }
          if (perWashEl && pNum) perWashEl.textContent = formatPerWash(pNum);
          if (savingsEl) {
            var s = cNum - pNum;
            if (s > 0) {
              var sFmt = (s/100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              savingsEl.textContent = 'Vous économisez ' + sFmt + ' €';
              savingsEl.hidden = false;
            } else {
              savingsEl.hidden = true;
            }
          }
          if (fromEl) fromEl.hidden = true;
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            var dflt = btn.getAttribute('data-fd-default-label') || 'J\'en profite à -20%';
            lbl.textContent = avail ? dflt : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
      });
    }

    function updateBubble(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newB = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        var cur = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        if (newB && cur) cur.innerHTML = newB.innerHTML;
      } catch (e) {}
    }
    function updateDrawer(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newC = parsed.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        var cur = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (newC && cur) cur.innerHTML = newC.innerHTML;
      } catch (e) {}
    }
    function openDrawer(){
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var toggles = ['[data-cart-drawer-toggle]','[aria-controls="cart-drawer"]','button[aria-controls*="cart"]','cart-drawer-toggle','a[href="/cart"]'];
      for (var i=0;i<toggles.length;i++){ var el = document.querySelector(toggles[i]); if (el){ el.click(); return true; } }
      ['cart:open','cart-drawer:open','cart:refresh:open'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
      return false;
    }
    function handleAtc(e){
      var form = e.target.closest('[data-fd-atc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var sp = form.querySelector('[data-fd-spinner]');
      if (btn) { btn.setAttribute('aria-busy','true'); btn.disabled = true; }
      if (sp) sp.hidden = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if (!r.ok) throw new Error('atc_'+r.status); return r.json(); })
        .then(function(data){
          if (data && data.sections) { updateDrawer(data.sections['cart-drawer']); updateBubble(data.sections['cart-icon-bubble']); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opened = openDrawer();
          if (!opened) setTimeout(function(){ window.location.href = '/cart'; }, 300);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.disabled = false; } if (sp) sp.hidden = true; });
    }

    if (!window.__fdAtcBound) {
      window.__fdAtcBound = true;
      document.addEventListener('submit', handleAtc);
    }

    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initSliders(section);
      initParfumVariants(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-parfums-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-parfums-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-parfums-v2"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initSliders(section){
      section.querySelectorAll('[data-fd-slider]').forEach(function(s){
        if (s.__fdSlider) return; s.__fdSlider = true;
        var track = s.querySelector('[data-fd-track]');
        var prev = s.querySelector('[data-fd-prev]');
        var next = s.querySelector('[data-fd-next]');
        var dots = s.querySelectorAll('[data-fd-dot]');
        if (!track) return;
        var slides = track.children;
        if (slides.length <= 1) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var activeClass = '';
        if (dots.length) {
          var m = (dots[0].className.match(/fd-[\w-]+__dot/) || [])[0];
          if (m) activeClass = m + '--active';
        }
        function step(dir){
          var w = track.clientWidth;
          var current = Math.round(track.scrollLeft / w);
          var target = Math.max(0, Math.min(slides.length - 1, current + dir));
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); step(-1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); step(1); });
        function updateUi(){
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (dots.length && activeClass) {
            dots.forEach(function(d, i){ d.classList.toggle(activeClass, i === idx); });
          }
          if (prev) prev.style.opacity = idx === 0 ? '.4' : '1';
          if (next) next.style.opacity = idx === slides.length - 1 ? '.4' : '1';
        }
        var scrollTimeout;
        track.addEventListener('scroll', function(){
          if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
          scrollTimeout = requestAnimationFrame(updateUi);
        }, { passive: true });
        updateUi();
      });
    }

    function initParfumVariants(section){
      var forms = section.querySelectorAll('[data-fd-pcard-form]');
      forms.forEach(function(form){
        if (form.__fdPcard) return; form.__fdPcard = true;
        var inputs = form.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var card = form.closest('.fd-parfums__card');
        var priceEl = card && card.querySelector('[data-fd-pcard-price]');
        var compareEl = card && card.querySelector('[data-fd-pcard-compare]');
        var perWashEl = card && card.querySelector('[data-fd-pcard-perwash]');
        var savingsEl = card && card.querySelector('[data-fd-pcard-savings]');
        var discountEl = card && card.querySelector('[data-fd-pcard-discount]');
        var fromEl = card && card.querySelector('.fd-parfums__price-from');
        var btn = form.querySelector('[data-fd-pcard-btn]');
        var lbl = btn && btn.querySelector('[data-fd-atc-label]');
        var track = card && card.querySelector('.fd-parfums__track');
        var slides = track ? track.querySelectorAll('.fd-parfums__slide img') : [];
        var defaultLabel = btn && btn.getAttribute('data-fd-default-label');
        if (btn && lbl && !defaultLabel) btn.setAttribute('data-fd-default-label', 'J\'en profite à -20%');
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function formatPerWash(priceCents){
          var euros = (priceCents / 10000);
          var fmt = euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return fmt + ' €/machine';
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-price');
          var compare = input.getAttribute('data-fd-compare');
          var pNum = parseInt(input.getAttribute('data-fd-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-available') === 'true';
          var im = input.getAttribute('data-fd-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          if (discountEl) {
            if (cNum > pNum) {
              var pct = Math.round((cNum - pNum) * 100 / cNum);
              discountEl.textContent = '-' + pct + '%';
              discountEl.hidden = false;
            } else {
              discountEl.hidden = true;
            }
          }
          if (perWashEl && pNum) perWashEl.textContent = formatPerWash(pNum);
          if (savingsEl) {
            var s = cNum - pNum;
            if (s > 0) {
              var sFmt = (s/100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              savingsEl.textContent = 'Vous économisez ' + sFmt + ' €';
              savingsEl.hidden = false;
            } else {
              savingsEl.hidden = true;
            }
          }
          if (fromEl) fromEl.hidden = true;
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            var dflt = btn.getAttribute('data-fd-default-label') || 'J\'en profite à -20%';
            lbl.textContent = avail ? dflt : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
      });
    }

    function updateBubble(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newB = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        var cur = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        if (newB && cur) cur.innerHTML = newB.innerHTML;
      } catch (e) {}
    }
    function updateDrawer(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newC = parsed.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        var cur = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (newC && cur) cur.innerHTML = newC.innerHTML;
      } catch (e) {}
    }
    function openDrawer(){
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var toggles = ['[data-cart-drawer-toggle]','[aria-controls="cart-drawer"]','button[aria-controls*="cart"]','cart-drawer-toggle','a[href="/cart"]'];
      for (var i=0;i<toggles.length;i++){ var el = document.querySelector(toggles[i]); if (el){ el.click(); return true; } }
      ['cart:open','cart-drawer:open','cart:refresh:open'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
      return false;
    }
    function handleAtc(e){
      var form = e.target.closest('[data-fd-atc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var sp = form.querySelector('[data-fd-spinner]');
      if (btn) { btn.setAttribute('aria-busy','true'); btn.disabled = true; }
      if (sp) sp.hidden = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if (!r.ok) throw new Error('atc_'+r.status); return r.json(); })
        .then(function(data){
          if (data && data.sections) { updateDrawer(data.sections['cart-drawer']); updateBubble(data.sections['cart-icon-bubble']); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opened = openDrawer();
          if (!opened) setTimeout(function(){ window.location.href = '/cart'; }, 300);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.disabled = false; } if (sp) sp.hidden = true; });
    }

    if (!window.__fdAtcBound) {
      window.__fdAtcBound = true;
      document.addEventListener('submit', handleAtc);
    }

    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initSliders(section);
      initParfumVariants(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-parfums-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-parfums-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-parfums"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initSliders(section){
      section.querySelectorAll('[data-fd-slider]').forEach(function(s){
        if (s.__fdSlider) return; s.__fdSlider = true;
        var track = s.querySelector('[data-fd-track]');
        var prev = s.querySelector('[data-fd-prev]');
        var next = s.querySelector('[data-fd-next]');
        var dots = s.querySelectorAll('[data-fd-dot]');
        if (!track) return;
        var slides = track.children;
        if (slides.length <= 1) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var activeClass = '';
        if (dots.length) {
          var m = (dots[0].className.match(/fd-[\w-]+__dot/) || [])[0];
          if (m) activeClass = m + '--active';
        }
        function step(dir){
          var w = track.clientWidth;
          var current = Math.round(track.scrollLeft / w);
          var target = Math.max(0, Math.min(slides.length - 1, current + dir));
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); step(-1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); step(1); });
        function updateUi(){
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (dots.length && activeClass) {
            dots.forEach(function(d, i){ d.classList.toggle(activeClass, i === idx); });
          }
          if (prev) prev.style.opacity = idx === 0 ? '.4' : '1';
          if (next) next.style.opacity = idx === slides.length - 1 ? '.4' : '1';
        }
        var scrollTimeout;
        track.addEventListener('scroll', function(){
          if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
          scrollTimeout = requestAnimationFrame(updateUi);
        }, { passive: true });
        updateUi();
      });
    }

    function initParfumVariants(section){
      var forms = section.querySelectorAll('[data-fd-pcard-form]');
      forms.forEach(function(form){
        if (form.__fdPcard) return; form.__fdPcard = true;
        var inputs = form.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var card = form.closest('.fd-parfums__card');
        var priceEl = card && card.querySelector('[data-fd-pcard-price]');
        var compareEl = card && card.querySelector('[data-fd-pcard-compare]');
        var perWashEl = card && card.querySelector('[data-fd-pcard-perwash]');
        var savingsEl = card && card.querySelector('[data-fd-pcard-savings]');
        var fromEl = card && card.querySelector('.fd-parfums__price-from');
        var btn = form.querySelector('[data-fd-pcard-btn]');
        var lbl = btn && btn.querySelector('[data-fd-atc-label]');
        var track = card && card.querySelector('.fd-parfums__track');
        var slides = track ? track.querySelectorAll('.fd-parfums__slide img') : [];
        var defaultLabel = btn && btn.getAttribute('data-fd-default-label');
        if (btn && lbl && !defaultLabel) btn.setAttribute('data-fd-default-label', 'J\'en profite à -20%');
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function formatPerWash(priceCents){
          var euros = (priceCents / 10000);
          var fmt = euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return fmt + ' €/machine';
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-price');
          var compare = input.getAttribute('data-fd-compare');
          var pNum = parseInt(input.getAttribute('data-fd-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-available') === 'true';
          var im = input.getAttribute('data-fd-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          if (perWashEl && pNum) perWashEl.textContent = formatPerWash(pNum);
          if (savingsEl) {
            var s = cNum - pNum;
            if (s > 0) {
              var sFmt = (s/100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              savingsEl.textContent = 'Vous économisez ' + sFmt + ' €';
              savingsEl.hidden = false;
            } else {
              savingsEl.hidden = true;
            }
          }
          if (fromEl) fromEl.hidden = true;
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            var dflt = btn.getAttribute('data-fd-default-label') || 'J\'en profite à -20%';
            lbl.textContent = avail ? dflt : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
      });
    }

    function updateBubble(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newB = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        var cur = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        if (newB && cur) cur.innerHTML = newB.innerHTML;
      } catch (e) {}
    }
    function updateDrawer(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newC = parsed.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        var cur = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (newC && cur) cur.innerHTML = newC.innerHTML;
      } catch (e) {}
    }
    function openDrawer(){
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var toggles = ['[data-cart-drawer-toggle]','[aria-controls="cart-drawer"]','button[aria-controls*="cart"]','cart-drawer-toggle','a[href="/cart"]'];
      for (var i=0;i<toggles.length;i++){ var el = document.querySelector(toggles[i]); if (el){ el.click(); return true; } }
      ['cart:open','cart-drawer:open','cart:refresh:open'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
      return false;
    }
    function handleAtc(e){
      var form = e.target.closest('[data-fd-atc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var sp = form.querySelector('[data-fd-spinner]');
      if (btn) { btn.setAttribute('aria-busy','true'); btn.disabled = true; }
      if (sp) sp.hidden = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if (!r.ok) throw new Error('atc_'+r.status); return r.json(); })
        .then(function(data){
          if (data && data.sections) { updateDrawer(data.sections['cart-drawer']); updateBubble(data.sections['cart-icon-bubble']); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opened = openDrawer();
          if (!opened) setTimeout(function(){ window.location.href = '/cart'; }, 300);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.disabled = false; } if (sp) sp.hidden = true; });
    }

    if (!window.__fdAtcBound) {
      window.__fdAtcBound = true;
      document.addEventListener('submit', handleAtc);
    }

    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initSliders(section);
      initParfumVariants(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-parfums-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-parfums-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-sticky"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
    function initSticky(section){
      var el = section.querySelector('[data-fd-sticky]');
      if (!el || el.__fdReady) return;
      el.__fdReady = true;
      if (sessionStorage.getItem('fd-sticky-dismissed') === '1') { el.remove(); return; }
      var deadline = new Date(section.getAttribute('data-fd-deadline')).getTime();
      var dEl = el.querySelector('[data-fd-sticky-d]');
      var hEl = el.querySelector('[data-fd-sticky-h]');
      var mEl = el.querySelector('[data-fd-sticky-m]');
      var sEl = el.querySelector('[data-fd-sticky-s]');
      var closeBtn = el.querySelector('[data-fd-sticky-close]');
      function render(){
        var diff = deadline - Date.now();
        if (diff <= 0) { el.remove(); return false; }
        if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
        if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
        if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
        if (sEl) sEl.textContent = pad(Math.floor((diff/1000)%60));
        return true;
      }
      function onScroll(){
        if (window.scrollY > 300) { el.hidden = false; el.setAttribute('data-fd-visible','1'); }
        else { el.removeAttribute('data-fd-visible'); }
      }
      if (closeBtn) closeBtn.addEventListener('click', function(){ sessionStorage.setItem('fd-sticky-dismissed','1'); el.remove(); });
      if (!render()) return;
      setInterval(render, 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      function isCartOpen(){
        var drawer = document.querySelector('cart-drawer, cart-notification, #CartDrawer, .cart-drawer, .drawer--cart, #cart-drawer');
        if (drawer) {
          if (drawer.classList.contains('active') || drawer.classList.contains('is-open') || drawer.classList.contains('open')) return true;
          if (drawer.hasAttribute('open')) return true;
          if (drawer.getAttribute('aria-hidden') === 'false') return true;
        }
        if (document.body.classList.contains('cart-drawer-open') || document.body.classList.contains('drawer-open') || document.documentElement.classList.contains('cart-open')) return true;
        return false;
      }
      function syncCart(){
        if (isCartOpen()) el.setAttribute('data-fd-cart-open','1');
        else el.removeAttribute('data-fd-cart-open');
      }
      var mo = new MutationObserver(syncCart);
      mo.observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class','open','aria-hidden'] });
      syncCart();
    }
    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initSticky(section);
    }
    function initAll(){
      document.querySelectorAll('.fd-section.fd-sticky-section').forEach(initSection);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-section.fd-sticky-section');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["french-days"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var pad = function(n){ return n < 10 ? '0' + n : '' + n; };

    function initCountdowns(root){
      var section = root || document;
      var deadlineEl = section.closest ? section.closest('[data-fd-deadline]') : section.querySelector('[data-fd-deadline]');
      var container = deadlineEl || section.querySelector('[data-fd-deadline]') || document.querySelector('[data-fd-deadline]');
      if (!container) return;
      var deadline = new Date(container.getAttribute('data-fd-deadline')).getTime();
      var timers = container.querySelectorAll('[data-fd-countdown]');
      timers.forEach(function(node){
        if (node.__fdBound) return;
        node.__fdBound = true;
        var dEl = node.querySelector('[data-fd-d]');
        var hEl = node.querySelector('[data-fd-h]');
        var mEl = node.querySelector('[data-fd-m]');
        var sEl = node.querySelector('[data-fd-s]');
        var timerEl = node.querySelector('[data-fd-timer]');
        var expiredEl = node.querySelector('.fd-countdown__expired');
        var labelEl = node.querySelector('.fd-countdown__label');
        var intervalId;
        function tick(){
          var diff = deadline - Date.now();
          if (diff <= 0) {
            if (timerEl) timerEl.hidden = true;
            if (labelEl) labelEl.hidden = true;
            if (expiredEl) expiredEl.hidden = false;
            if (intervalId) clearInterval(intervalId);
            return;
          }
          var days  = Math.floor(diff / 86400000);
          var hours = Math.floor((diff / 3600000) % 24);
          var mins  = Math.floor((diff / 60000) % 60);
          var secs  = Math.floor((diff / 1000) % 60);
          if (dEl) dEl.textContent = pad(days);
          if (hEl) hEl.textContent = pad(hours);
          if (mEl) mEl.textContent = pad(mins);
          if (sEl) sEl.textContent = pad(secs);
        }
        tick();
        intervalId = setInterval(tick, 1000);
      });
    }

    function initSticky(section){
      var el = section.querySelector('[data-fd-sticky]');
      if (!el || el.__fdReady) return;
      el.__fdReady = true;
      if (sessionStorage.getItem('fd-sticky-dismissed') === '1') { el.remove(); return; }
      var root = section;
      var deadline = new Date(root.getAttribute('data-fd-deadline')).getTime();
      var dEl = el.querySelector('[data-fd-sticky-d]');
      var hEl = el.querySelector('[data-fd-sticky-h]');
      var mEl = el.querySelector('[data-fd-sticky-m]');
      var closeBtn = el.querySelector('[data-fd-sticky-close]');
      function render(){
        var diff = deadline - Date.now();
        if (diff <= 0) { el.remove(); return false; }
        if (dEl) dEl.textContent = pad(Math.floor(diff/86400000));
        if (hEl) hEl.textContent = pad(Math.floor((diff/3600000)%24));
        if (mEl) mEl.textContent = pad(Math.floor((diff/60000)%60));
        return true;
      }
      function onScroll(){
        if (window.scrollY > 300) { el.hidden = false; el.setAttribute('data-fd-visible','1'); }
        else { el.removeAttribute('data-fd-visible'); }
      }
      if (closeBtn) closeBtn.addEventListener('click', function(){ sessionStorage.setItem('fd-sticky-dismissed','1'); el.remove(); });
      if (!render()) return;
      setInterval(render, 30000);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    function initParfumVariants(section){
      var forms = section.querySelectorAll('[data-fd-pcard-form]');
      forms.forEach(function(form){
        if (form.__fdPcard) return; form.__fdPcard = true;
        var inputs = form.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var card = form.closest('.fd-parfums__card');
        var priceEl = card && card.querySelector('[data-fd-pcard-price]');
        var compareEl = card && card.querySelector('[data-fd-pcard-compare]');
        var perWashEl = card && card.querySelector('[data-fd-pcard-perwash]');
        var savingsEl = card && card.querySelector('[data-fd-pcard-savings]');
        var fromEl = card && card.querySelector('.fd-parfums__price-from');
        var btn = form.querySelector('[data-fd-pcard-btn]');
        var lbl = btn && btn.querySelector('[data-fd-atc-label]');
        var track = card && card.querySelector('.fd-parfums__track');
        var slides = track ? track.querySelectorAll('.fd-parfums__slide img') : [];
        var defaultLabel = btn && btn.getAttribute('data-fd-default-label');
        if (btn && lbl && !defaultLabel) btn.setAttribute('data-fd-default-label', 'J\'en profite à -20%');
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function formatPerWash(priceCents){
          var euros = (priceCents / 10000);
          var fmt = euros.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return fmt + ' €/machine';
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-price');
          var compare = input.getAttribute('data-fd-compare');
          var pNum = parseInt(input.getAttribute('data-fd-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-available') === 'true';
          var im = input.getAttribute('data-fd-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          if (perWashEl && pNum) perWashEl.textContent = formatPerWash(pNum);
          if (savingsEl) {
            var s = cNum - pNum;
            if (s > 0) {
              var sFmt = (s/100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              savingsEl.textContent = 'Vous économisez ' + sFmt + ' €';
              savingsEl.hidden = false;
            } else {
              savingsEl.hidden = true;
            }
          }
          if (fromEl) fromEl.hidden = true;
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            var dflt = btn.getAttribute('data-fd-default-label') || 'J\'en profite à -20%';
            lbl.textContent = avail ? dflt : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
      });
    }

    function initBundleSwatches(section){
      var bundles = section.querySelectorAll('.fd-bundle');
      bundles.forEach(function(b){
        if (b.__fdSwatch) return; b.__fdSwatch = true;
        var inputs = b.querySelectorAll('input[type="radio"][name="id"]');
        if (!inputs.length) return;
        var priceEl = b.querySelector('[data-fd-bundle-price]');
        var compareEl = b.querySelector('[data-fd-bundle-compare]');
        var btn = b.querySelector('[data-fd-bundle-btn]');
        var lbl = btn && btn.querySelector('[data-fd-atc-label]');
        var track = b.querySelector('.fd-bundle__track');
        var slides = track ? track.querySelectorAll('.fd-bundle__slide img') : [];
        function basename(u){
          if (!u) return '';
          var s = u.split('?')[0].split('/').pop();
          return s.replace(/_\d+x\d*\./, '.').replace(/_\d+x\./, '.');
        }
        function scrollToVariantImage(im){
          if (!track || !im || !slides.length) return;
          var target = basename(im);
          if (!target) return;
          for (var i=0; i<slides.length; i++){
            if (basename(slides[i].getAttribute('src')) === target || basename(slides[i].currentSrc || '') === target) {
              track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
              return;
            }
          }
        }
        function onChange(input){
          var price = input.getAttribute('data-fd-price');
          var compare = input.getAttribute('data-fd-compare');
          var pNum = parseInt(input.getAttribute('data-fd-price-num')||'0',10);
          var cNum = parseInt(input.getAttribute('data-fd-compare-num')||'0',10);
          var avail = input.getAttribute('data-fd-available') === 'true';
          var im = input.getAttribute('data-fd-img');
          if (priceEl && price) priceEl.textContent = price;
          if (compareEl) {
            if (cNum > pNum && compare) { compareEl.textContent = compare; compareEl.hidden = false; }
            else { compareEl.hidden = true; }
          }
          scrollToVariantImage(im);
          if (btn && lbl) {
            btn.disabled = !avail;
            lbl.textContent = avail ? 'Ajouter le pack au panier' : 'Rupture de stock';
          }
        }
        inputs.forEach(function(i){ i.addEventListener('change', function(){ onChange(i); }); });
        var checked = b.querySelector('input[type="radio"][name="id"]:checked');
        if (checked) onChange(checked);
      });
    }

    function updateBubble(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newB = parsed.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        var cur = document.querySelector('#cart-icon-bubble, .cart-count-bubble, [data-cart-icon-bubble]');
        if (newB && cur) cur.innerHTML = newB.innerHTML;
      } catch (e) {}
    }
    function updateDrawer(html){
      if (!html) return;
      try {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newC = parsed.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        var cur = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
        if (newC && cur) cur.innerHTML = newC.innerHTML;
      } catch (e) {}
    }
    function openDrawer(){
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var toggles = ['[data-cart-drawer-toggle]','[aria-controls="cart-drawer"]','button[aria-controls*="cart"]','cart-drawer-toggle','a[href="/cart"]'];
      for (var i=0;i<toggles.length;i++){ var el = document.querySelector(toggles[i]); if (el){ el.click(); return true; } }
      ['cart:open','cart-drawer:open','cart:refresh:open'].forEach(function(n){ document.dispatchEvent(new CustomEvent(n,{bubbles:true})); });
      return false;
    }

    function handleAtc(e){
      var form = e.target.closest('[data-fd-atc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var sp = form.querySelector('[data-fd-spinner]');
      if (btn) { btn.setAttribute('aria-busy','true'); btn.disabled = true; }
      if (sp) sp.hidden = false;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if (!r.ok) throw new Error('atc_'+r.status); return r.json(); })
        .then(function(data){
          if (data && data.sections) { updateDrawer(data.sections['cart-drawer']); updateBubble(data.sections['cart-icon-bubble']); }
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opened = openDrawer();
          if (!opened) setTimeout(function(){ window.location.href = '/cart'; }, 300);
        })
        .catch(function(){ form.submit(); })
        .finally(function(){ if (btn){ btn.removeAttribute('aria-busy'); btn.disabled = false; } if (sp) sp.hidden = true; });
    }

    function initSliders(section){
      section.querySelectorAll('[data-fd-slider]').forEach(function(s){
        if (s.__fdSlider) return; s.__fdSlider = true;
        var track = s.querySelector('[data-fd-track]');
        var prev = s.querySelector('[data-fd-prev]');
        var next = s.querySelector('[data-fd-next]');
        var dots = s.querySelectorAll('[data-fd-dot]');
        if (!track) return;
        var slides = track.children;
        if (slides.length <= 1) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var activeClass = '';
        if (dots.length) {
          var m = (dots[0].className.match(/fd-[\w-]+__dot/) || [])[0];
          if (m) activeClass = m + '--active';
        }
        function step(dir){
          var w = track.clientWidth;
          var current = Math.round(track.scrollLeft / w);
          var target = Math.max(0, Math.min(slides.length - 1, current + dir));
          track.scrollTo({ left: target * w, behavior: 'smooth' });
        }
        if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); step(-1); });
        if (next) next.addEventListener('click', function(e){ e.preventDefault(); step(1); });
        function updateUi(){
          var w = track.clientWidth;
          if (!w) return;
          var idx = Math.round(track.scrollLeft / w);
          if (dots.length && activeClass) {
            dots.forEach(function(d, i){ d.classList.toggle(activeClass, i === idx); });
          }
          if (prev) prev.style.opacity = idx === 0 ? '.4' : '1';
          if (next) next.style.opacity = idx === slides.length - 1 ? '.4' : '1';
        }
        var scrollTimeout;
        track.addEventListener('scroll', function(){
          if (scrollTimeout) cancelAnimationFrame(scrollTimeout);
          scrollTimeout = requestAnimationFrame(updateUi);
        }, { passive: true });
        updateUi();
      });
    }

    function initSection(section){
      if (!section || section.__fdInit) return;
      section.__fdInit = true;
      initCountdowns(section);
      initSliders(section);
      initParfumVariants(section);
      initBundleSwatches(section);
      initSticky(section);
    }

    function initAll(){
      document.querySelectorAll('.fd-fd[data-fd-deadline]').forEach(initSection);
    }

    if (!window.__fdAtcBound) {
      window.__fdAtcBound = true;
      document.addEventListener('submit', handleAtc);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', function(e){
      var s = e.target.querySelector('.fd-fd[data-fd-deadline]');
      if (s) { s.__fdInit = false; initSection(s); }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
